import { Get } from './helpers';

export const GetHCArticles = async (search: string): Promise<any> => {
	return Get(`https://help.brand.live/api/v2/help_center/articles/search?query=${search}`, '', {}, true)
		.then(async res => {
			if (res.ok) {
				return await res.json();
			}

			throw new Error('Unable to get help center articles');
		});
};
